const businessTerviceTrade = [
  {
    expand: false,
    children: [
      {
        value: 57,
        label: '1.仅限海陆空物流运输费'
      },
      {
        value: 58,
        label: '2.仓库租赁仓储费'
      },
      {
        value: 59,
        label: '3.邮政及速递服务'
      },
      {
        value: 60,
        label: '4.护卫及武装运送服务'
      }
    ],
    value: 0,
    label: '1.物流服务：运输、仓库、邮政及速递服务'
  },
  {
    expand: false,
    children: [
      {
        value: 2,
        label: '1.电子商务和系统开发'
      },
      {
        value: 3,
        label: '2.商业程序'
      },
      {
        value: 4,
        label: '3.游戏程序'
      },
      {
        value: 5,
        label: '4.技术检测和维护'
      },
      {
        value: 6,
        label: '5.系统安全和咨讯安全'
      }
    ],
    value: 1,
    label: '2.软件, 移动或电脑程序开发'
  },
  {
    expand: false,
    children: [
      {
        value: 8,
        label: '1.持牌第三方支付运营商'
      },
      {
        value: 9,
        label: '2.持牌银行'
      },
      {
        value: 10,
        label: '3.持牌资产管理'
      },
      {
        value: 11,
        label: '4.持牌外汇交易平台商及外币兑换店'
      },
      {
        value: 12,
        label: '5.融资财务公司'
      },
      {
        value: 13,
        label: '6.储值支付工具'
      },
      {
        value: 14,
        label: '7.信托服务'
      },
      {
        value: 15,
        label: '8.充值支付,预付卡,电子钱包平台'
      },
      {
        value: 16,
        label: '9.债务重组及追收'
      },
      {
        value: 61,
        label: '10.持牌借贷公司'
      },
      {
        value: 62,
        label: '11.贵金属和大宗商品买卖'
      },
      {
        value: 63,
        label: '12.手机支付'
      },
      {
        value: 64,
        label: '13.非持牌经营支付交易'
      }
    ],
    value: 7,
    label: '3.金融'
  },
  {
    expand: false,
    value: 17,
    label: '4.保险业服务'
  },
  {
    expand: false,
    children: [
      {
        value: 19,
        label: '1.地产租赁'
      },
      {
        value: 20,
        label: '2.地产买卖'
      },
      {
        value: 21,
        label: '3.物业代理'
      },
      {
        value: 22,
        label: '4.楼宇管理及物业保养服务'
      }
    ],
    value: 18,
    label: '5.地产'
  },
  {
    expand: false,
    children: [
      {
        value: 24,
        label: '1.通讯、电讯服务，如流动虚拟网络营办商、对外电讯服务'
      },
      {
        value: 25,
        label: '2.航空器上流动通讯服务'
      },
      {
        value: 26,
        label: '3.因特网接入'
      },
      {
        value: 27,
        label: '4.国际电话卡、话音邮箱服务及国际增值网络'
      },
      {
        value: 28,
        label: '5.其他'
      }
    ],
    value: 23,
    label: '6.资讯及通讯'
  },
  {
    expand: false,
    children: [
      {
        value: 30,
        label: '1.海外院校入学服务'
      },
      {
        value: 31,
        label: '2.驾驶学校服务'
      },
      {
        value: 32,
        label: '3.海外留学住宿'
      },
      {
        value: 33,
        label: '4.海外留学交通服务'
      }
    ],
    value: 29,
    label: '7.教育'
  },
  {
    expand: false,
    children: [
      {
        value: 35,
        label: '1.法律'
      },
      {
        value: 36,
        label: '2.会计及商业关税'
      },
      {
        value: 37,
        label: '3.移民顾问'
      },
      {
        value: 38,
        label: '4.职业介绍(人力资源和就业介绍)'
      },
      {
        value: 39,
        label: '5.广告及公共关系'
      },
      {
        value: 40,
        label: '6.秘书及翻译服务'
      },
      {
        value: 41,
        label: '7.专利注册'
      },
      {
        value: 42,
        label: '8.旅行社航旅咨询'
      },
      {
        value: 43,
        label: '9.机械及商用设备租赁'
      },
      {
        value: 44,
        label: '10.保安顾问和系统设置'
      },
      {
        value: 65,
        label: '11.财务管理规划顾问'
      },
      {
        value: 66,
        label: '12.设计(产品,时装,其他)'
      }
    ],
    value: 34,
    label: '8.专业顾问及商用服务'
  },
  {
    expand: false,
    children: [
      {
        value: 67,
        label: '1.物业维修, 保养, 设备安装'
      },
      {
        value: 68,
        label: '2.废金属杂物和废料'
      },
      {
        value: 69,
        label: '3.室内设计装饰及工程'
      }
    ],
    value: 45,
    label: '9.建筑及建造'
  },
  {
    expand: false,
    children: [
      {
        value: 70,
        label: '1.酒店和住宿'
      },
      {
        value: 71,
        label: '2.餐饮,承包膳食,外卖服务'
      }
    ],
    value: 46,
    label: '10.住宿及膳食服务'
  },
  {
    expand: false,
    value: 47,
    label: '11.人类保健及社会工作活动'
  },
  {
    expand: false,
    children: [
      {
        value: 72,
        label: '1.博物馆和美术馆'
      },
      {
        value: 73,
        label: '2.健身,体育运动,舞蹈芭蕾'
      },
      {
        value: 74,
        label: '3.青少年和儿童中心'
      },
      {
        value: 75,
        label: '4.电视电影,歌剧,管弦乐'
      },
      {
        value: 76,
        label: '5.媒体服务'
      },
      {
        value: 77,
        label: '6.時装表演,表演团体'
      }
    ],
    value: 48,
    label: '12.艺术、娱乐及康乐活动'
  },
  {
    expand: false,
    children: [
      {
        value: 50,
        label: '1.公共行政'
      },
      {
        value: 51,
        label: '2.生活相关,摄影,侦探,家庭教师,家佣'
      },
      {
        value: 52,
        label: '3.拍卖行'
      },
      {
        value: 53,
        label: '4.商会及厂商会等'
      },
      {
        value: 54,
        label: '5.贵宾保安服务'
      }
    ],
    value: 49,
    label: '13.其他个人化及商会服务'
  },
  {
    expand: false,
    value: 55,
    label: '14.采矿及采石'
  },
  {
    expand: false,
    children: [
      {
        value: 78,
        label: '1.清洁服务包括空调,车辆,建筑物'
      },
      {
        value: 79,
        label: '2.供水和污水废物管理'
      },
      {
        value: 80,
        label: '3.废料回收'
      }
    ],
    value: 56,
    label: '15.自来水供应、污水处理及废弃物管理'
  },
  {
    expand: false,
    value: 81,
    label: '16.多层直销'
  },
  {
    expand: false,
    value: 82,
    label: '17.大型连锁店/百货商店'
  },
  {
    expand: false,
    value: 83,
    label: '18.能源管理及环境顾问服务'
  }
]
export default businessTerviceTrade
